
(() => {
  const init = () => {
    if (!document.body.classList.contains('vma-page')) return;
    document.querySelectorAll('.vma-footer-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const mobile = matchMedia('(max-width: 899px)');
      const sync = () => {
        menu.open = !mobile.matches;
        menu.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
      };
      sync();
      mobile.addEventListener('change', sync);
      menu.querySelector('summary').addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      });
    });
    document.querySelectorAll('.vma-navigation details').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('.vma-navigation details').forEach(other => {
          if (other !== menu) other.open = false;
        });
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
    });
    document.querySelectorAll('.vma-film-stage').forEach(stage => {
      const video = stage.querySelector('video');
      const button = stage.querySelector('.vma-film-play');
      if (!video || !button || stage.dataset.ready) return;
      stage.dataset.ready = 'true';
      video.playsInline = true;
      button.hidden = !video.paused;
      button.addEventListener('click', () => {
        video.play().catch(() => { button.hidden = false; const fallback = stage.querySelector('.vma-film-fallback'); if (fallback) fallback.hidden = false; });
      });
      video.addEventListener('play', () => { button.hidden = true; const fallback = stage.querySelector('.vma-film-fallback'); if (fallback) fallback.hidden = true; });
      video.addEventListener('error', () => { const fallback = stage.querySelector('.vma-film-fallback'); if (fallback) fallback.hidden = false; });
      video.addEventListener('pause', () => { button.hidden = false; });
      video.addEventListener('ended', () => { button.hidden = false; });
    });
    document.querySelectorAll('.vma-press').forEach(press => {
      if (press.dataset.ready) return;
      press.dataset.ready = 'true';
      press.classList.add('is-scrolling');

    });
    document.querySelectorAll('[data-vma-slideshow]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      const slides = [...gallery.querySelectorAll('.vma-hero-slide')];
      const controls = gallery.querySelector('.vma-hero-slide-controls');
      if (slides.length < 2 || !controls) return;
      gallery.dataset.ready = 'true';
      controls.hidden = false;
      const dots = [...gallery.querySelectorAll('[data-slide-index]')];
      const pause = gallery.querySelector('.vma-hero-pause');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, paused = reduced.matches, changing = false;
      const syncPause = () => {
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute('aria-label', paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel);
      };
      const show = async next => {
        if (changing || next === index) return;
        changing = true;
        const image = slides[next].querySelector('img');
        try { if (image && image.decode) await image.decode(); } catch { changing = false; return; }
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === next);
          slide.setAttribute('aria-hidden', String(i !== next));
          dots[i].setAttribute('aria-pressed', String(i === next));
        });
        index = next;
        gallery.querySelector('.vma-hero-slide-count').textContent = `0${index + 1} / 0${slides.length}`;
        changing = false;
      };
      dots.forEach((dot, i) => dot.addEventListener('click', () => { paused = true; syncPause(); show(i); }));
      pause.addEventListener('click', () => { paused = !paused; syncPause(); });
      reduced.addEventListener('change', () => { paused = reduced.matches; syncPause(); });
      syncPause();
      const timer = setInterval(() => {
        if (!gallery.isConnected) { clearInterval(timer); return; }
        if (!paused && !document.hidden && !gallery.matches(':hover') && !gallery.contains(document.activeElement)) show((index + 1) % slides.length);
      }, 6000);
    });
    const sticky = document.querySelector('[data-vma-sticky]');
    const hero = document.querySelector('.vma-hero');
    const purchase = document.querySelector('.vma-purchase');
    if (sticky && hero && purchase && !sticky.dataset.ready && 'IntersectionObserver' in window) {
      sticky.dataset.ready = 'true';
      let heroVisible = true, purchaseVisible = false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.target === hero) heroVisible = entry.isIntersecting; else purchaseVisible = entry.isIntersecting; });
        sticky.hidden = heroVisible || purchaseVisible;
      }, {threshold: 0});
      observer.observe(hero); observer.observe(purchase);
    }
    document.querySelectorAll('.vma-product-form select[name="id"]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const section = select.closest('.vma-purchase');
        const button = select.form.querySelector('button[type="submit"]');
        section.querySelector('[data-vma-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-vma-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = option.dataset.sale !== 'true';
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
      });
    });
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      document.body.classList.add('vma-motion');
      const reveal = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.add('vma-reveal');reveal.unobserve(entry.target);}}), {threshold:.12});
      document.querySelectorAll('.vma-heading-row,.vma-anatomy header,.vma-display-copy').forEach(el => reveal.observe(el));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
